import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SystemOperator from "./SystemOperator";
import MonitoredObject from "./MonitoredObject";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";
import ConstructionCompany from "./ConstructionCompany";
import InstallationCompany from "./InstallationCompany";

const AdressesTab: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    return <>
        <SettingsCol >
            <SettingsLabel text={"TRVB_OBJECT_HEADER"} labelPosition={'floating'} lines={'none'} />
            <MonitoredObject systemId={systemId} />
            <SettingsLabel text={"[REACT_USER_OF_SYSTEM]"} labelPosition={'floating'} lines={'none'} />
            <SystemOperator systemId={systemId} />
        </SettingsCol>
        <SettingsCol >
            <SettingsLabel text={"[REACT_SYSTEM_INSTALLER_COMPANY]"} labelPosition={'floating'} lines={'none'} />
            <ConstructionCompany systemId={systemId} />
        </SettingsCol>
        <SettingsCol >
            <SettingsLabel text={"[REACT_ELECTRICAL_INSTALLER_COMPANY]"} labelPosition={'floating'} lines={'none'} />
            <InstallationCompany systemId={systemId} />
        </SettingsCol>
    </>;
};

export default AdressesTab;
